export const TOKEN_STORAGE_KEY = 'onyx_merchant_token';
export const PENDING_2FA_KEY = 'onyx_merchant_pending_2fa';
export const ENV_STORAGE_KEY = 'onyx_portal_environment';
